import { observer } from 'mobx-react-lite';
import React from 'react';

import { TabItem, TabPanel, Tabs } from '@flixbus/honeycomb-react';

import { TABS_MODS } from 'pages/WorkAssignments/WorkAssignmentsStore';

import styles from 'pages/WorkAssignments/styles.module.css';

const WorkAssignmentsTabs = observer(function WorkAssignmentsTabs({ store }) {
	const tabs = Object.keys(TABS_MODS).map((key) => {
		const tab = TABS_MODS[key];

		return (
			<TabItem
				key={key}
				id={tab.tabId}
				panelId={tab.panelId}
				active={tab.tabId === store.currentSearchMode.tabId}
				extraClasses={styles.tab}
			>
				{tab.label}
			</TabItem>
		);
	});

	const panels = Object.keys(TABS_MODS).map((key) => {
		const tab = TABS_MODS[key];
		return <TabPanel key={tab.panelId} id={tab.panelId} tabId={tab.tabId} />;
	});

	const onTabActivated = (tabId) => {
		const tabConfig = Object.values(TABS_MODS).find((t) => t.tabId === tabId) ?? TABS_MODS.all;
		store.setSearchMode(tabConfig);
	};

	return (
		<Tabs
			navRest={{
				Elem: 'section',
				'aria-label': 'Search results for modes',
			}}
			tabs={tabs}
			panels={panels}
			onTabActivated={onTabActivated}
		/>
	);
});

export default WorkAssignmentsTabs;
